import {
  Component,
  EventEmitter,
  Inject,
  Input,
  Optional,
  Output,
} from '@angular/core';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'pl-infobox',
  templateUrl: './pl-infobox.component.html',
  styleUrls: ['./pl-infobox.component.scss'],
})
export class PlInfoboxComponent {
  @Input() visible = false;

  @Input() type: 'error' | undefined;

  @Input() iconName = 'priority_high';

  @Input() canClose = true;

  @Output() readonly closed: EventEmitter<void> = new EventEmitter();

  message: string;

  close() {
    if (this.data) {
      this.snackBar.dismiss();
      return;
    }
    this.visible = false;
    this.closed.emit();
  }

  constructor(
    @Optional() @Inject(MAT_SNACK_BAR_DATA) private data?: any,
    @Optional() private snackBar?: MatSnackBar
  ) {
    if (data) {
      this.type = data.type;
      this.iconName = data.icon;
      this.message = data.message;
      this.visible = true;
    }
  }
}
